/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Typography, Chip, Card, CardContent, CardMedia, Divider, Link } from '@material-ui/core';
import {
  Settings,
  Flag,
  LocationOn,
  Person,
  Edit,
  PlayArrow,
  PhoneAndroid,
  AccountCircle,
  Stop,
  InsertDriveFile,
  Info,
  Build,
} from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { getTime, getTaskTypeName, startTask } from '../../helperFunctions';
import {
  setShowTaskDetails,
  setConfirmationDialog,
  setTaskUpdated,
  openEndTaskDialog,
} from '../redux';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { TaskChatChip } from '../../Chat';

export default props => {
  const { task } = props;
  const { width } = useWindowDimensions();
  const taskType = getTaskTypeName(task.type);
  const dispatch = useDispatch();
  const taskStarted = useSelector(state => state.tasks.taskStarted);
  const data = useSelector(state => state.tasks.data);
  const taskUpdated = useSelector(state => state.tasks.taskUpdated);
  const isAdmin = useSelector(state => state.auth.isAdmin);
  const fontSize = width <= 500 ? '3vw' : '15px';
  const startLabel = getTime(task.start);
  const endLabel = getTime(task.end);

  let headerShadow = {
    boxShadow:
      '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
  };
  let backgroundColor = task.type === 3 ? '#da291c' : '#a5daff';

  if (taskStarted.started && taskStarted.taskId === task.id) {
    backgroundColor = '#7e0009';
  }

  if (taskUpdated.taskId === task.id) {
    headerShadow = { boxShadow: '0px 0px 20px 4px rgba(255, 0, 0, 1)' };
    setTimeout(() => dispatch(setTaskUpdated({ taskId: null })), 3000);
  }
  return (
    <Card
      key={task.id}
      style={{ ...headerShadow, marginTop: '5px', opacity: task.status === '-' ? '1.0' : '0.3' }}
    >
      <CardMedia>
        <div style={{ backgroundColor, padding: '3px' }}>
          {task.type === 3 ? (
            <Chip
              style={{ margin: '1px', marginRight: '2px' }}
              avatar={<Settings />}
              onClick={() => dispatch(setShowTaskDetails({ open: true, taskId: task.id }))}
              clickable
              label={`${startLabel} - ${taskStarted.started && taskStarted.taskId === task.id ? '?' : endLabel
                }`}
            />
          ) : (
            <Chip
              style={{ margin: '1px', marginRight: '2px' }}
              label={`${startLabel} - ${taskStarted.started && taskStarted.taskId === task.id ? '?' : endLabel
                }`}
            />
          )}
          {task.type === 3 && !taskStarted.started && task.status === '-' && (
            <Chip
              avatar={<PlayArrow />}
              onClick={() =>
                dispatch(
                  setConfirmationDialog({
                    open: true,
                    title: [{ text: 'Стартиране на задача ?' }],
                    onConfirm: () => startTask(data, task, dispatch),
                    onCancel: () =>
                      dispatch(
                        setConfirmationDialog({
                          open: false,
                          title: [],
                          onConfirm: null,
                          onCancel: null,
                        })
                      ),
                  })
                )
              }
              clickable
            />
          )}
          <TaskChatChip task={task} />
          {taskStarted.started && task.id === taskStarted.taskId && (
            <Chip
              avatar={<Stop />}
              onClick={() =>
                dispatch(
                  openEndTaskDialog({
                    open: true,
                    taskId: task.id,
                  })
                )
              }
              clickable
            />
          )}
        </div>
      </CardMedia>
      <CardContent>
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          <Flag style={{ fontSize, marginRight: '2px' }} />
          {task.ticketTypeName || taskType || task.manualTicketType}
          <br />
          {task.service}
          <br />
          {task.ticketId && `Билет: ${task.ticketId}`}
          {isAdmin && (
            <>
              <br />
              {`TaskId: ${task.id}`}
            </>
          )}
        </Typography>

        {data.ticketRouterMessages[task.ticketId] && (
          <>
            <Divider />
            <Typography style={{ color: 'red', fontWeight: 1000 }}>
              {data.ticketRouterMessages[task.ticketId]}
            </Typography>
          </>
        )}

        {task.address && (
          <>
            <Divider />
            <Link
              href={`https://maps.google.com/maps?q=${task.latitude},${task.longitude}`}
              target="_blank"
              rel="noreferrer"
            >
              <Typography gutterBottom component="span" style={{ fontSize }}>
                <LocationOn style={{ fontSize, marginRight: '2px' }} />
                {task.address}
              </Typography>
            </Link>
          </>
        )}

        <>
          <Divider />
          {task.client && (
            <Typography gutterBottom component="p" style={{ fontSize }}>
              <Person style={{ fontSize, marginRight: '2px' }} />
              <span>{task.client}</span>
            </Typography>
          )}
          {task.phone && (
            <Typography gutterBottom component="p" style={{ fontSize }}>
              <PhoneAndroid style={{ fontSize, marginRight: '2px' }} />
              {task.phone}
            </Typography>
          )}
          {task.clientNo && (
            <Typography gutterBottom component="p" style={{ fontSize }}>
              <AccountCircle style={{ fontSize, marginRight: '2px' }} />
              {task.clientNo}
            </Typography>
          )}
        </>
        {task.shopManagerInfo && (
          <>
            <Divider />
            <div style={{ display: 'flex' }}>
              <Info style={{ fontSize, marginRight: '2px' }} />
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography gutterBottom component="p" style={{ fontSize }}>
                  {task.shopManagerInfo.shopManagerNote}
                </Typography>
                <Typography gutterBottom component="p" style={{ fontSize }}>
                  {task.shopManagerInfo.employeeNote}
                </Typography>
              </div>
            </div>
          </>
        )}
        {task.assignedSysAdmins && task.assignedSysAdmins.length > 0 && (
          <>
            <Divider />
            <div style={{ display: 'flex' }}>
              <Build style={{ fontSize, marginRight: '2px' }} />
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {task.assignedSysAdmins.map(x => (
                  <Typography gutterBottom component="p" style={{ fontSize }}>
                    {`Назначен системен администратор ${x}`}
                  </Typography>
                ))}
              </div>
            </div>
          </>
        )}
        {task.note && (
          <>
            <Divider />
            <Typography gutterBottom component="p" style={{ fontSize }}>
              <Edit style={{ fontSize, marginRight: '2px' }} />
              {task.note}
            </Typography>
          </>
        )}
        {task?.documentsDashboard?.documentMessage && (
          <>
            <Divider />
            <Typography style={{ color: 'red', fontWeight: 1000 }}>
              <InsertDriveFile style={{ fontSize, marginRight: '2px' }} />
              {task.documentsDashboard.documentMessage}
            </Typography>
          </>
        )}

        {task.smartDevicesNote && (
          <>
            <Divider />
            <Typography style={{ color: 'red', fontWeight: 1000 }}>
              {task.smartDevicesNote}
            </Typography>
          </>
        )}
      </CardContent>
    </Card>
  );
};
